import request from '@/utils/request'

  export function index(id) {
    return request({
      url: `/assent/my_requests/${id}`,
      method: 'get',
      
    })
  }
